import { FetchRequestError } from "./FetchRequestError";

export class FetchPasswordInvalidError extends FetchRequestError {
  /**
   * Backend-intended user flow: the user-supplied password failed validation
   * (e.g. wrong current password, doesn't meet policy) and the form surfaces
   * the failure inline. Suppress from RUM/Sentry to avoid inflating
   * monitoring with non-actionable events.
   */
  override isUnexpectedSystemError(): boolean {
    return false;
  }
}
